import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '@nh/angular-tses';
import {EnvironmentVariableService} from 'app/core/services/environment-variable.service';
import {ReasonCodeService} from 'app/diary/reason-codes/reason-codes.service';
import {Reassignment, RoleService} from '../../../core/services/role.service';
import {DiaryService} from '../../../diary/diary.service';
import {DepartureRole} from '../../../permissions/types';
import {TransitionInputData} from '../transition-input-data';
import {UserAssignModalComponent} from '../user-assign-modal/user-assign-modal.component';

@Component({
  selector: 'das-specialist-assign-modal',
  templateUrl: './specialist-assign-modal.component.html',
  styleUrls: [
    './specialist-assign-modal.component.scss',
    '../base-transition-modal/base-transition-modal.component.scss',
  ],
})
export class SpecialistAssignModalComponent extends UserAssignModalComponent {
  constructor(
    public dialogRef: MatDialogRef<UserAssignModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransitionInputData,
    roleService: RoleService,
    diaryService: DiaryService,
    reasonCodeService: ReasonCodeService,
    environmentVariableService: EnvironmentVariableService
  ) {
    super(dialogRef, data, roleService, diaryService, reasonCodeService, environmentVariableService);
  }

  public assign(): void {
    if (!this._technicalSpecialistIsAssigned()) {
      this._assignAuthorisingSignatoryAsTechnicalSpecialist();
    }
    super.assign();
  }

  private _assignAuthorisingSignatoryAsTechnicalSpecialist() {
    super.selected(this._getSelectedAuthorisingSignatory(), {role: DepartureRole.TECHNICAL_SPECIALIST, users: []});
  }

  private _getSelectedAuthorisingSignatory(): User {
    const authSignatoryReassignment: Reassignment = this.reassignments.find(
      (reassignment: Reassignment) => reassignment.role === DepartureRole.AUTHORISING_SIGNATORY
    );
    return authSignatoryReassignment.user as User;
  }

  private _technicalSpecialistIsAssigned(): boolean {
    return (
      this._rolesAssigned(DepartureRole.TECHNICAL_SPECIALIST) ||
      this.reassignments.some((reassignment: Reassignment) => {
        return reassignment.role === DepartureRole.TECHNICAL_SPECIALIST && !!reassignment.user;
      })
    );
  }

  /**
   * Determines if the given role is required to be assigned.
   *
   * @param role {DepartureRole}   Departure role to assign
   * @returns    {boolean}         True if the role requires assignment
   */
  public isRequiredAssignment(role: DepartureRole): boolean {
    return role === DepartureRole.AUTHORISING_SIGNATORY;
  }
}
